import { getPaymentReport } from './states';

export const services = {
  getPaymentReport,
};
